import config from '../common/config';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { fromJS } from 'immutable';
import { connect } from 'react-redux';
import { Grid, Cell } from 'react-flexr';

import ProductCategory from '../common/product-category';
import { SearchPanel, SearchGroup, Slider } from '../common/search';
import TagFilter from '../common/tagFilter';
import Showcase from '../common/showcase';

function fixValue(value) {
  if(value === undefined || value === null) {
    return '-';
  } else if(value === 0) {
    return 'Ubegrænset';
  }
  return value;
}

const UNLIMITED_PERSONS = 10;
const UNLIMITED_PREP = 60;
const UNLIMITED_DAYS = 7;
@connect(({ mealbox: { offers } }) => ({ offers }))
@withRouter
class Offers extends ProductCategory {
  constructor(props) {
    super(props);

    this.state = this.mapPropsToState(props, {
      offerType: 'måltidskasse',
      ...this.state,
      defaultFilters: { // FOR FILTERS_USED EPI
        tags: []
      },
      filters: {
        tags: [],
        ...(this.state.filters || {})
      }
    });
  }

  resetFilter() {
    const filters = {
      ...(this.state.filters || {}),
      tags: []
    };
    
    this.setState({
      filters,
      filter: this.createFilter(filters)
    });
  }

  serialiseOffer(offer) {
    const tags = offer.get('tags') ? offer.get('tags').toJS() : [];
    const manualTags = offer.get('manualTags') ? Array.from(offer.get('manualTags')) : [];
    const mergedTags = tags.reduce((acc, tag) => {
      if(!acc.includes(tag)) {
        acc.push(tag);
      }
      return acc;
    }, manualTags || []).filter(Boolean);

    const result = fromJS({
      id: offer.get('_id'),

      provider: offer.get('provider'),
      product: offer.get('product'),
      logo:
        offer.getIn(['image', 'hash']) &&
        `${config.images}${offer.getIn(['image', 'hash'])}`,
      link: `/redirect/${offer.get('uuid')}`,
      tagline: offer.get('tagline'),
      orderText: 'Se mulige tilvalg',

      details: [
        {
            value: [offer.get('personMin'), offer.get('personMax')].join(' - '), 
            unit: '',
            label: 'Personer'
        },
        {
          value: [offer.get('preperationMin'), offer.get('preperationMax')].join(' - '), 
          unit: 'min.',
          label: 'Forberedelse'
        }
      ].filter(Boolean),

      prices: [
        {
          value: [offer.get('daysMin'), offer.get('daysMax')].join(' - '), 
          unit: '',
          label: 'Dage'
        },
        {
          value: offer.getIn(['price', 'portion']) || '-',
          unit: 'kr.',
          label: 'Per portion'
        }
      ],

      price: {
        value: offer.getIn(['price', 'portion']) || '-',
        unit: 'kr.',
        label: 'Per portion'
      },

      usps: []
        .concat(mergedTags, offer.get('services').toJS())
        .filter(Boolean),

      productDescription: offer.get('productDescription'),
      discountCode: offer.get('discountCode'),
      tags: tags.map((v) => typeof v === 'string' ? v.trim(): '').filter(Boolean),

      _raw: offer
    });

    return result;
  }

  createFilter(filters) {
    this.updateFiltersUsed(filters);
    return offers =>
      offers.filter(offer => {
        const tags = Array.from(offer.get('usps'));
        const services = Array.from(offer.getIn(['_raw', 'services']));
        const filteredTags = filters.tags;

        const lowerCaseTags = tags.map(i => i.toLowerCase());
        const lowerCaseServices = services.map(i => i.toLowerCase());
        const lowerCaseProvider = offer.get('provider').toLowerCase().trim().replace('-', ' ');

        for (let idx = 0; idx < filteredTags.length; idx++) {
          const tag = filteredTags[idx];
          if (
            !lowerCaseServices.includes(tag) &&
            !lowerCaseTags.includes(tag) && 
            !tags.includes(tag) &&
            !services.includes(tag) &&
            tag.toLowerCase() !== lowerCaseProvider) {
            return false;
          }
        }

        if(filters.persons && filters.persons !== UNLIMITED_PERSONS) {
          if(filters.persons < offer.getIn(['_raw', 'personMin']) || filters.persons > offer.getIn(['_raw', 'personMax'])) {
            return false;
          }
        }

        if(filters.preperation && filters.preperation !== UNLIMITED_PREP) {
          if(filters.preperation < offer.getIn(['_raw', 'preperationMin']) || filters.preperation > offer.getIn(['_raw', 'preperationMax'])) {
            return false;
          }
        }

        if(filters.days && filters.days !== UNLIMITED_DAYS) {
          if(filters.days < offer.getIn(['_raw', 'daysMin']) || filters.days > offer.getIn(['_raw', 'daysMax'])) {
            return false;
          }
        }

        return true;
      });
  }

  getPersons(value) {
    if (value) {
      const val = parseInt(value[0]);
      if (val == UNLIMITED_PERSONS || val === 0) {
        return 'Alle';
      }
      return `${val}`;
    }
    return '';
  }

  getPrep(value) {
    if (value) {
      const val = parseInt(value[0]);
      if (val == UNLIMITED_PREP || val === 0) {
        return 'Alle';
      }
      return `${val} min.`;
    }
    return '';
  }

  getDays(value) {
    if (value) {
      const val = parseInt(value[0]);
      if (val == UNLIMITED_PREP || val === 0) {
        return 'Ubegrænset';
      }
      return `${val} dage`;
    }
    return '';
  }

  render() {
    const { offers, filter, filters, showcases } = this.state;

    return (
      <Grid>
        <Cell size='3/12' portable='1/1'>
          <SearchPanel
            title={'Måltidskasser'}
            filter={filter}
            results={offers}
            filterTexts={this.createSearchDisplay(filters)}
          >
            <SearchGroup>
              <Slider
                name='persons'
                connect='lower'
                disconnected={filters.persons === null}
                headline={['Personer', this.getPersons]}
                units={['Alle', '10+ | Alle']}
                min={0}
                max={10}
                range={{
                  min: [0, 1],
                  '5%': [1, 1],
                  '50%': [5, 1],
                  max: [UNLIMITED_PERSONS]
                }}
                defaultStart={[filters.persons || UNLIMITED_PERSONS]}
                onSlide={this.sliderOnChange}
              />
              <Slider
                name='preperation'
                connect='lower'
                disconnected={filters.preperation === null}
                headline={['Tilberedningstid', this.getPrep]}
                units={['Alle', '60+ min. | Alle']}
                min={0}
                max={60}
                range={{
                  min: [0, 5],
                  '35%': [20, 5],
                  '50%': [30, 5],
                  max: [UNLIMITED_PREP]
                }}
                defaultStart={[filters.preperation || UNLIMITED_PREP]}
                onSlide={this.sliderOnChange}
              />
              <Slider
                name='days'
                connect='lower'
                disconnected={filters.days === null}
                headline={['Minimum dage', this.getDays]}
                units={['Ubegrænset', '7+ dage | Ubegrænset']}
                min={0}
                max={7}
                range={{
                  min: [0, 1],
                  '10%': [1, 1],
                  '60%': [4, 1],
                  max: [UNLIMITED_DAYS]
                }}
                defaultStart={[filters.days || UNLIMITED_DAYS]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>
            <TagFilter
              headline={'Tags'}
              feed={this.state.feed}
              offerType={this.state.offerType}
              items={offers}
              filters={filters}
              checkboxOnChange={this.tagsOnChange}
            />
          </SearchPanel>
        </Cell>
        <Cell>
          <Showcase list={showcases} orderText='Se mulige tilvalg' site_id={this.state.siteId} feed={this.state.feed} url={this.state.url} filters_used={this.state.filtersUsed}/>
          {this.renderResults(null, this.resetFilter.bind(this))}
        </Cell>
      </Grid>
    );
  }
}

export default Offers;
